import { Check } from "lucide-react";
import { formatCompactUsd } from "@/lib/format";

// True linear positions. Labels fan out below the ticks so the first three never overlap.
export const CHECKPOINTS = [
  { id: "100k", fraction: 0.01 }, { id: "500k", fraction: 0.05 },
  { id: "1m", fraction: 0.1 }, { id: "2-5m", fraction: 0.25 },
  { id: "5m", fraction: 0.5 }, { id: "7-5m", fraction: 0.75 }, { id: "10m", fraction: 1 },
];

export const EnergyCheckpoints = ({ marketCap, target, known }) => (
  <div className="energy-checkpoints" data-testid="energy-core-checkpoints">
    <svg className="energy-checkpoints__leaders" viewBox="0 0 700 28" preserveAspectRatio="none" aria-hidden="true">
      {CHECKPOINTS.map(({ id, fraction }, i) => (
        <path key={id} d={`M${fraction * 700} 0 V7 L${i * 100 + 50} 21 V28`}
          data-reached={known && marketCap >= target * fraction} />
      ))}
    </svg>
    <ol className="energy-checkpoints__labels">
      {CHECKPOINTS.map(({ id, fraction }) => {
        const reached = known && marketCap >= target * fraction;
        return (
          <li key={id} data-testid={`energy-core-checkpoint-${id}`} data-reached={reached} data-final={fraction === 1}
            aria-label={`${formatCompactUsd(target * fraction)}: ${reached ? "reached" : "not reached"}`}>
            <span className="energy-checkpoints__node" aria-hidden="true">{reached && <Check />}</span>
            <span data-testid={`energy-core-checkpoint-${id}-label`}>{formatCompactUsd(target * fraction)}</span>
          </li>
        );
      })}
    </ol>
  </div>
);